<template>
  <router-view />
</template>

<script>
export default {
  name: 'ClientsGroupsIndex'
}
</script>
